import { useNotifications } from "@/hooks/_archive/global/notifications/useNotifications"
import { Component } from "@/types/types"
import { Stack } from "@/ui/atoms/layout/Stack"
import { NotificationCard } from "@/ui/blocks/notifications/NotificationCard"
import { cx } from "@/utils/cx"
import { useSearchParams } from "next/navigation"
export const presets = {}

export interface Props extends Component {}

export function NotificationCardsManager({ className = "" }: Props) {
  const [notifications] = useNotifications()
  const searchParams = useSearchParams()
  const disableNotificationCards = searchParams.get("disableNotificationCards")

  if (disableNotificationCards) return

  return (
    <div>
      <Stack className={cx(`fixed inset-0 top-auto p-4 max-w-[432px]`, "space-y-3", className)}>
        {notifications.slice(0, 3).map((notification) => (
          <NotificationCard
            {...notification}
            className={cx("drop-shadow !rounded-lg")}
            key={notification.id}
          />
        ))}
      </Stack>
    </div>
  )
}
